import React, { Component } from "react";
import CustomizedSelect from "./customizedSelect";
import { connect } from "react-redux";
import {
  getNewPurchaseFundList,
  physicalTransaction,
} from "../../../store/actions";

import { PHYSICAL_NEW, EXISTING, NEW, YES } from "../../../store/types";
import MenuItem from "@material-ui/core/MenuItem";
import { Input } from "../../forms/input";
import UploadFile from "../uploadFile";
import Signbutton from "../../forms/button";
import CustomizedDialogs from "../customModal";
import { NEW_TRANSACTION_URL } from ".";

import CustomLoader from "../../forms/Loader";
import { Checkbox } from "@material-ui/core";

class NfoPhysicalMode extends Component {
  constructor(props) {
    super(props);
    const { investorData, communicationDetails = [] } = this.props;
    const Xmobile = (communicationDetails || []).find(
      (detail) => detail.PAN === investorData.PAN && !!detail.Mobile
    );
    const Xemail = (communicationDetails || []).find(
      (detail) => detail.PAN === investorData.PAN && !!detail.email
    );
    const Email = !!Xemail && !!Xemail.email ? Xemail.email : "";
    const Mobile = !!Xmobile && !!Xmobile.Mobile ? Xmobile.Mobile : "";
    this.state = {
      emailId: { value: Email },
      mobile: { value: Mobile },
      fund: { value: "189" },
      upload: { errorMessage: "" },
      sipTypes: [
        { label: "Existing Folio - SIP Registration", value: EXISTING },
        { label: "New Folio - SIP Registration with payment", value: NEW },
      ],
      sipType: { value: "" },
      file: {},
      disabled: false,
      fundsList: [],
      fundList: [],
      open: false,
      folio: {
        value: this.props.location.state.type !== PHYSICAL_NEW ? "" : "0",
      },
      submitting: false,
      terms: true,
      refno: "",
    };
  }

  // componentWillMount() {
  //   // this.setState({
  //   //   fundsList: this.funds(this.props),
  //   // });
  // }

  funds = (props) => {
    let { fundsList } = props;
    const { type, flag } = this.props.location.state;
    if (type !== PHYSICAL_NEW) {
      if (!!flag) {
        fundsList = fundsList.filter((item) => item[flag] === YES);
      }
      fundsList = fundsList.reduce((prev, curr) => {
        const findIndex =
          prev.findIndex((fund) => fund.Fund === curr.Fund) !== -1;
        if (!findIndex) {
          return [...prev, { Fund: curr.Fund, FundDesc: curr.FundDesc }];
        }
        return prev;
      }, []);
    }
    return fundsList;
  };

  changeValue = (label) => (event) => {
    if (label === "mobile" && event.target.value.length <= 10) {
      this.setState({
        [label]: { value: event.target.value },
      });
    } else if (label !== "mobile") {
      this.setState({
        [label]: { value: event.target.value },
      });
    }
  };

  showError = (label) => () => {
    const {
      [label]: { value },
    } = this.state;
    if (label === "emailId") {
      this.setState({
        [label]: {
          value,
          isError:
            /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/.test(
              this.state.emailId.value
            ) === false
              ? true
              : !value,
          errorMessage:
            /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/.test(
              this.state.emailId.value
            ) === false
              ? `( *enter an vaild email address )`
              : "",
        },
      });
    } else if (label === "mobile") {
      this.setState({
        [label]: {
          value,
          isError:
            /^(?:(?:\+|0{0,2})91(\s*[\-]\s*)?|[0]?)?[6-9]\d{9}$/.test(
              this.state.mobile.value
            ) === false
              ? true
              : !value,
          errorMessage:
            /^(?:(?:\+|0{0,2})91(\s*[\-]\s*)?|[0]?)?[6-9]\d{9}$/.test(
              this.state.mobile.value
            ) === false
              ? `(* Enter a valid Phone Number)`
              : !value,
        },
      });
    } else {
      this.setState({
        [label]: {
          value,
          isError: !value,
        },
      });
    }
  };
  handleSipTypeChange = (event) => {
    const sipType = event.target.value;

    const state = {
      schemeType: EXISTING,
      email: { value: "" },

      mobile: { value: "" },
    };
    if (!sipType) {
      this.setState({
        ...state,
        sipType: { value: event.target.value },
      });
      return;
    } else if (event.target.value === this.state.sipType.value) {
      return;
    }
    const { fundList, fundsList } = this.props;

    const funds =
      sipType === EXISTING
        ? this.funds(this.props)
        : fundList.map((fund) => ({
            Fund: fund.amc_code,
            FundDesc: fund.amc_name,
            AadharFlag: fund.Aadhar,
          }));
    this.setState({
      // ...state,
      sipType: { value: event.target.value },
      // fundsList: funds,
      fund: { value: "189" },
      folio: { value: "" },
    });
  };

  componentDidMount() {
    window.scrollTo({
      behavior: "smooth",
      top: 0,
    });
    const fund = "189";
    let folios = [];
    const { type, flag } = this.props.location.state;
    let { fundsList } = this.props;
    if (type !== PHYSICAL_NEW) {
      if (!!flag) {
        fundsList = fundsList.filter((item) => item[flag] === YES);
      }
      folios = fundsList.reduce((prev, curr) => {
        if (curr.Fund === fund) {
          return [...prev, curr.Acno];
        }
        return prev;
      }, []);
    }
    this.setState({
      fund: { value: fund },
      folios: Array.from(new Set(folios)),
    });
  }

  fundChange = (event) => {
    const fund = event.target.value;
    let folios = [];
    const { type, flag } = this.props.location.state;
    let { fundsList } = this.props;
    if (type !== PHYSICAL_NEW) {
      if (!!flag) {
        fundsList = fundsList.filter((item) => item[flag] === YES);
      }
      folios = fundsList.reduce((prev, curr) => {
        if (curr.Fund === fund) {
          return [...prev, curr.Acno];
        }
        return prev;
      }, []);
    }
    this.setState({
      fund: { value: fund },
      folios: Array.from(new Set(folios)),
    });
  };

  fileUpload = (label) => (e) => {
    if (!!e.target.files.length) {
      const file = e.target.files[0];
      this.setState({
        [label]: file.name,
      });

      var fileReader = new FileReader();
      var base64;
      // Onload of file read the file content
      fileReader.onload = (fileLoadedEvent) => {
        base64 = fileLoadedEvent.target.result;
        // Print data in console
        this.setState({
          file: { value: base64.split(",")[1] },
        });
      };
      // Convert data to base64
      fileReader.readAsDataURL(file);
      this.setState({
        upload: { errorMessage: "Upload Successfully" },
      });
    }
  };

  closeModal = () => {
    this.setState({
      open: false,
    });
    this.props.history.replace(NEW_TRANSACTION_URL);
  };

  toggleCheckbox = () => {
    this.setState({ terms: !this.state.terms });
  };

  submit = async () => {
    const {
      upload_file,
      fundsList,
      open,
      fund,
      folios,
      disabled,
      refno,
      submitting,
      upload,
      sipType,
      sipTypes,
      fundList,
      folio,
      terms,
      ...others
    } = this.state;
    const { type } = this.props.location.state;
    const keys = Object.keys(others);

    const findError = keys.every((key) => !!others[key].value);

    if (!findError) {
      keys.forEach((key) => {
        !others[key].value &&
          this.setState({ [key]: { ...others[key], isError: true } });
      });
      const firstErroredKey = keys.find((key) => !others[key].value);
      switch (firstErroredKey) {
        case "emailId": {
          this.emailIdField.focus();
          break;
        }
        case "mobile": {
          this.mobileField.focus();
          break;
        }
        case "fund": {
          this.fundField.focus();
          break;
        }
      }
    } else if (
      !this.state.folio.value &&
      this.state.sipType.value === EXISTING
    ) {
      this.setState({
        folio: {
          value: "",
          isError: true,
          errorMessage: "folio is mandatory",
        },
      });
    } else if (
      !!this.state.emailId.value &&
      /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/.test(
        this.state.emailId.value
      ) === false
    ) {
      this.setState({
        emailId: {
          ...others["emailId"],
          isError: true,
          errorMessage: `Enter a vaild Email address`,
        },
      });
      return;
    } else if (
      !!this.state.mobile.value &&
      /^(?:(?:\+|0{0,2})91(\s*[\-]\s*)?|[0]?)?[6-9]\d{9}$/.test(
        this.state.mobile.value
      ) === false
    ) {
      this.setState({
        mobile: {
          ...others["mobile"],
          isError: true,
          errorMessage: `Enter a vaild Phone number`,
        },
      });
      return;
    } else {
      this.setState({ submitting: true });
      const payload = {
        email: others.emailId.value,
        folio: this.state.folio.value || "0",
        fund: "189",
        customfund: "189",
        mobile: others.mobile.value,
        pan: this.props.investorData.PAN || "",
        Pdffile: others.file.value,
        reqtype: type,
        userid: this.props.userId,
      };

      const response = await this.props.physicalTransaction(payload);

      if (
        !!response &&
        !!response.DtData &&
        !!response.DtData[0] &&
        !!response.DtData[0].ihno
      ) {
        this.setState({ open: true, refno: response.DtData[0].ihno });
      }
      this.setState({ submitting: false });
    }
  };

  render() {
    const {
      emailId,
      mobile,
      fund,
      folio,
      fundsList = [],
      fundList = [],
      folios = [],
      sipType,
      sipTypes,
      terms,
    } = this.state;
    const type = this.props.location.state.type;
    return (
      <React.Fragment>
        <CustomLoader display={this.state.submitting} />
        <div className="input-margin">
          {type === "isip" && (
            <div className="input-margin">
              <CustomizedSelect
                placeholder="Select SIP Type"
                name="SIP Type"
                borderColor="#a6a6a6"
                handleChange={this.handleSipTypeChange}
                value={sipType.value}
                inputRef={(ele) => (this.sipTypeField = ele)}
                isError={sipType.isError}
                errorMessage={sipType.errorMessage}
              >
                {sipTypes.map((item, index) => (
                  <MenuItem value={item.value} key={index}>
                    {item.label}
                  </MenuItem>
                ))}
              </CustomizedSelect>
            </div>
          )}
        </div>

        {type !== PHYSICAL_NEW && this.state.sipType.value !== NEW && (
          <div className="input-margin">
            <CustomizedSelect
              name="Folio"
              handleChange={this.changeValue("folio")}
              value={folio.value}
              disabled={!fund.value}
              placeholder="Select Folio"
              inputRef={(ele) => (this.folioField = ele)}
              isError={folio.isError}
            >
              {folios.map((item, index) => (
                <MenuItem value={item} key={index}>
                  {item}
                </MenuItem>
              ))}
            </CustomizedSelect>
          </div>
        )}
        <div className="input-margin">
          <Input
            name="Email ID"
            value={emailId.value}
            onChange={this.changeValue("emailId")}
            onBlur={this.showError("emailId")}
            isShowError={emailId.isError}
            inputref={(ele) => (this.emailIdField = ele)}
            errorMessage={this.state.emailId.errorMessage}
          />
        </div>

        <div className="input-margin">
          <Input
            name="Phone No"
            onKeyDown={(evt) =>
              (evt.key === "e" || evt.key === "." || evt.key === "-") &&
              evt.preventDefault()
            }
            value={mobile.value}
            type="number"
            onChange={this.changeValue("mobile")}
            onBlur={this.showError("mobile")}
            isShowError={mobile.isError}
            errorMessage={mobile.errorMessage}
            inputref={(ele) => (this.mobileField = ele)}
          />
        </div>
        <div className="input-margin">
          {!!this.state.upload.errorMessage ? (
            <div
              style={{
                color:
                  !!this.state.upload.errorMessage &&
                  this.state.upload.errorMessage == "Upload Successfully"
                    ? "green"
                    : "red",
                fontFamily: "Rubik-Italic",
                fontSize: 15,
              }}
            >
              {this.state.upload.errorMessage}
            </div>
          ) : (
            ""
          )}
          <UploadFile
            id="upload_file"
            uploadFile={this.fileUpload}
            fileName={this.state.upload_file}
            isShowError={this.state.file.isError}
          />
          <div className="euin-text">
            Only .pdf files allowed. File size to not exceed 24 MB
          </div>
        </div>

        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Checkbox
            onClick={this.toggleCheckbox}
            // value={combo.label}
            checked={terms}
            color="secondary"
          />
          <span>
            I have understood and agree to your{" "}
            <a
              style={{
                fontSize: 13,
                color: "#005DAC",
                textDecoration: "underline",
              }}
              href={"/terms-conditions"}
              target="_blank"
            >
              Terms and Conditions
            </a>{" "}
            of the Phygital Mode
          </span>
        </div>

        <div className="digital-form-button-next-div">
          <Signbutton
            customStyle={{ paddingBottom: 20 }}
            buttontitle={this.state.submitting ? "Submitting..." : "Submit"}
            disabled={this.state.submitting}
            marginTop={"0"}
            onClick={
              !!terms
                ? this.submit
                : () => alert("Please Read Terms and Conditions")
            }
          />
        </div>
        <CustomizedDialogs
          open={this.state.open}
          closeModal={this.closeModal}
          Nctihno={this.state.refno}
          reqtype={
            type === "new"
              ? " New Purchase "
              : type === "add"
              ? " Additional Purchase "
              : type === "isip"
              ? " SIP "
              : type === "swop"
              ? " Switch "
              : type === "red"
              ? " Redemption "
              : ""
          }
        />
      </React.Fragment>
    );
  }
}

export default connect(
  ({ authReducer, transactions }, props) => {
    const { location } = props;
    const { investorData, communicationDetails, token, userId } = authReducer;
    const { fundsList } = transactions;
    const { fundList } = authReducer;

    return {
      investorData,
      communicationDetails,
      token,
      fundList: location.state.type === "isip" ? fundsList : [],
      fundsList: location.state.type === PHYSICAL_NEW ? fundsList : fundList,
      userId,
    };
  },
  {
    getNewPurchaseFundList,
    physicalTransaction,
  }
)(NfoPhysicalMode);
